module.exports = "/_next/static/images/image-b66a18fccf69e326e1ec3276430d20b9.jpg";